import React from 'react';
import { CheckboxProps } from 'types/Checkbox';
import { Field } from 'react-final-form';
import { FormFieldProps } from 'types/TextField';
import Checkbox from '../Checkbox';

function FormCheckbox( {
  name,
  value,
  field,
  validate,
  onChange,
  ...rest
}: CheckboxProps & FormFieldProps ) {
  return field
    ? (
      <Field name={field} validate={validate}>
        {( { meta, input, isInvalid } ) => (
          <Checkbox
            name={field}
            value={input.value}
            onChange={( newValue, event ) => {
              if ( onChange ) onChange( newValue, event );
              input.onChange( newValue );
            }}
            isInvalid={isInvalid}
            meta={meta}
            {...rest}
          />
        )}
      </Field>
    ) : (
      <Checkbox
        name={name || 'checkbox'}
        value={value}
        onChange={onChange}
        {...rest}
      />
    );
}

export default FormCheckbox;
